import React, {
  createContext,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import { getERTPageList, getERTPageDetails } from "../../api/Api";

export const EvacuationContext = createContext({});
export const EvacuationContextProvider = ({ children }) => {
  const previousPage = location?.state?.status;
  const navigate = useNavigate();

  const [ertData, setERTData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
const [spinnerStatus ,setSpinnerStatus] = useState(false)
  const handleAlertSubmit = () => {
    setShowAlert(false);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const goBack = () => {
    navigate(-1);
  };

  const getERTData = async () => {
    setSpinnerStatus (true)
    try {
      const getData = await getERTPageList();
      if (getData?.data?.status === 200) {
        setERTData(getData?.data?.data);
        setSpinnerStatus (false)
      }
    } catch (error) {
      setSpinnerStatus (false)
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const evacuactionDetailPage = async (pageName, id) => {
    try {
      const getERTCategoryData = await getERTPageDetails(id);
      const getERTCategoryListData = getERTCategoryData?.data?.data;

      if (getERTCategoryData?.data?.status === 200) {
        navigate(RouteConstants.ERT_DETAILS, {
          state: {
            mainId: id,
            pageName,
            previousPage,
            getERTCategoryListData,
          },
        });
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error.response.data.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    getERTData();
  }, []);

  const providerValue = {
    goBack,
    ertData,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    handleAlertSubmit,
    evacuactionDetailPage,
    statusCode,
    spinnerStatus ,setSpinnerStatus
  };
  return (
    <EvacuationContext.Provider value={providerValue}>
      {children}
    </EvacuationContext.Provider>
  );
};
